module.exports = __webpack_public_path__ + "b16cfe9914712b78c20eaf1171d31056.svg";